import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { psLabel, fundLast4 } from "@/lib/payments";

// Paid directly by the 529 plan: a read-only line, never a picker. A plan is
// not kept with bank accounts and cards, so no payment account is recorded.
// The plan is named only when the beneficiary has exactly one live plan —
// with two, naming either would be a guess. Same words as the expense form.
// (ZEN-53, ZEN-764)
export function planPaidLabel(funds, ownerName, beneficiaryName) {
  if ((funds || []).length !== 1) return "";
  const fa = funds[0];
  return psLabel({ type: "529_plan", state: fa.state, last4: fundLast4(fa) },
    ownerName || "", beneficiaryName || "") || fa.provider || "";
}

// The one sentence both the expense form and the import review show (ZEN-819).
export function PaidByPlanText({ label, nick }) {
  return label
    ? <span>Paid directly from <span className="font-semibold">{label}</span> — no bank account or card was used.</span>
    : <span>Paid directly from {nick}&rsquo;s 529 account — no bank account or card was used.</span>;
}

export function PaidByPlanLine({ studentId, ownerName, beneficiaryName, beneficiaryNick, testid }) {
  const { data: funds = [] } = useQuery({
    queryKey: ["fund-accounts", studentId],
    queryFn: async () => (await api.get(`/fund-accounts?student_id=${studentId}&include_archived=false`)).data,
    enabled: !!studentId,
  });
  const label = planPaidLabel(funds, ownerName, beneficiaryName);
  return (
    <div className="flex min-h-10 items-center rounded-md border border-[#C2C9D1] bg-[#F8FAFC] px-3 py-2 text-sm text-[#374151]" data-testid={testid}>
      <PaidByPlanText label={label} nick={beneficiaryNick} />
    </div>
  );
}
